import { render, staticRenderFns } from "./TodasRedesSociais.vue?vue&type=template&id=55935400&scoped=true&"
import script from "./TodasRedesSociais.vue?vue&type=script&lang=js&"
export * from "./TodasRedesSociais.vue?vue&type=script&lang=js&"
import style0 from "./TodasRedesSociais.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TodasRedesSociais.vue?vue&type=style&index=1&id=55935400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55935400",
  null
  
)

export default component.exports